var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMicrosoftIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#microsoftIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F35325",
  d: "M1.043 1.047h10.435v10.435H1.043z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#81BC06",
  d: "M12.522 1.047h10.435v10.435H12.522z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#05A6F0",
  d: "M1.043 12.523h10.435v10.435H1.043z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFBA08",
  d: "M12.522 12.523h10.435v10.435H12.522z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "microsoftIcon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h24v24H0z"
})))));
export default SvgMicrosoftIcon;